import { mockComponent } from 'bloko/common/setupMockComponents';

export default mockComponent('NotificationFooter', null, {
    withChildren: true,
});
